<template>
  <div class="home">
    <b-form @submit="onSubmit">
      <b-row>
        <b-col></b-col>
        <b-col cols="9">
          <b-form-group id="input-group-1" label="" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="form.username"
              type="text"
              required
              placeholder="Username"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-2" label="" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="form.password"
              type="password"
              required
              placeholder="Password"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>

      <b-row>
        <b-col></b-col>
        <b-col cols="9">
          <b-button block class="float-right" type="submit" variant="primary">
            <b-icon-unlock></b-icon-unlock>
          </b-button>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios';
import fixed from '../fixed';

export default {
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
    };
  },
  async mounted() {
    try {
      await axios.get(`${fixed.API_URL}/authenticated`, { withCredentials: true });
      await this.$router.push('/');
    } catch (error) {
      this.$toast.info('Please use your credentials to log in');
    }
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();
      const formData = new FormData();
      formData.set('username', this.form.username);
      formData.set('password', this.form.password);
      try {
        const resp = await axios.post(fixed.BASE_URL, formData, { withCredentials: true });
        if (resp.status === 200) {
          localStorage.setItem('user', JSON.stringify(resp.data));
          window.location.reload();
        }
      } catch (error) {
        this.$toast.error(error?.response?.data);
      }
    },
  },
};
</script>

<style>

</style>
